import React from 'react';
import { TrendingUp } from 'lucide-react';
import { hashColor } from '../../utils/colors';
import { isMetal, METAL_DISPLAY } from '../../utils/metals';
import { isStockOrETF, isETF } from '../../utils/stocks';

// Shared coin/asset icon renderer. `size` is the pixel diameter (default 32).
export function CoinIcon({
  coinId,
  symbol,
  imageMap,
  size = 32,
}: {
  coinId: string;
  symbol: string;
  imageMap: Record<string, string>;
  size?: number;
}) {
  const box: React.CSSProperties = { width: size, height: size };
  const fontPx = Math.max(8, Math.round(size * 0.32));

  if (isMetal(coinId)) {
    return (
      <div
        className="rounded-full flex items-center justify-center font-bold flex-shrink-0"
        style={{ ...box, backgroundColor: METAL_DISPLAY[coinId].bg, border: `1.5px solid ${METAL_DISPLAY[coinId].border}` }}
      >
        <span style={{ color: METAL_DISPLAY[coinId].color, fontSize: fontPx }}>{METAL_DISPLAY[coinId].label}</span>
      </div>
    );
  }
  if (isStockOrETF(coinId)) {
    return (
      <div
        className="rounded-full flex items-center justify-center flex-shrink-0"
        style={{
          ...box,
          backgroundColor: isETF(coinId) ? '#8B5CF615' : '#3B82F615',
          border: `1.5px solid ${isETF(coinId) ? '#8B5CF640' : '#3B82F640'}`,
        }}
      >
        <TrendingUp style={{ width: size * 0.44, height: size * 0.44, color: isETF(coinId) ? '#8B5CF6' : '#3B82F6' }} />
      </div>
    );
  }
  if (imageMap[coinId]) {
    return (
      <img
        src={imageMap[coinId]}
        alt={symbol}
        className="rounded-full flex-shrink-0 object-cover"
        style={box}
        onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
      />
    );
  }
  return (
    <div
      className="rounded-full flex items-center justify-center font-bold flex-shrink-0"
      style={{ ...box, backgroundColor: hashColor(coinId) + '30', border: `1.5px solid ${hashColor(coinId)}50` }}
    >
      <span style={{ color: hashColor(coinId), fontSize: fontPx }}>{symbol.slice(0, 2)}</span>
    </div>
  );
}
